export const TEXTOS = {
  TITULO: 'Selección de cuenta',
  BAJADA: 'Elegí la cuenta con la cual quieras comenzar a gestionar',
  BUSCADOR_PLACEHOLDER: 'Buscar por razón social, contrato, CUIT o póliza',
  CUENTA_CONECTADA_PREFIJO: 'Estás en la cuenta:',
  INGRESAR: 'Ingresar',
  INGRESANDO: 'Ingresando...',
}

export const MENSAJES_GRILLA = {
  SIN_CUENTAS: {
    TITULO: 'No tenés cuentas asociadas',
    DESCRIPCION: 'Comunicate con tu administrador para asociar una cuenta.',
  },
  // Criterio 11 — el texto pedido se reparte entre título y descripción.
  SIN_RESULTADOS: {
    TITULO: 'No se encontraron resultados',
    DESCRIPCION: 'Modificá o eliminá los datos ingresados.',
  },
  ERROR: {
    TITULO: 'No se pudieron cargar las cuentas',
    DESCRIPCION: 'Intentá nuevamente más tarde.',
  },
}

// Sólo mensajes de error: cuando el cambio sale bien se redirige al PHP, así
// que no hay pantalla donde mostrar una confirmación.
export const MENSAJES_INGRESO = {
  ERROR: 'No se pudo cambiar de cuenta. Intentá nuevamente.',
  ERROR_RED: 'No se pudo cambiar de cuenta por un problema de conexión. Intentá nuevamente.',
}

/** Estado con el que el backend marca las solicitudes de asociación todavía no aprobadas. */
export const ESTADO_PENDIENTE = 'Pendiente'

export const PAGE_SIZE_INICIAL = 10
